module.exports = __webpack_public_path__ + "static/img/nr.d16edc69.svg";